import { Language } from "@faire/web-api--source/indigofair/languages/Language";
import { messageToGibberish } from "./gibberish";
export var createFormatMessage = function(localeKey, formatMessageFn) {
    if ((localeKey === null || localeKey === void 0 ? void 0 : localeKey.language) === Language.STRING_ID) {
        return function(descriptor) {
            return descriptor.id;
        };
    }
    if ((localeKey === null || localeKey === void 0 ? void 0 : localeKey.language) === Language.GIBBERISH) {
        return function(descriptor, values, opts) {
            return formatMessageFn({
                defaultMessage: messageToGibberish(descriptor.defaultMessage),
                id: descriptor.id
            }, values, opts);
        };
    }
    return formatMessageFn;
};
